<template>
<div>
  <el-dialog title="接口申请" :visible.sync="dialogFormVisible" @close="cancelDialog">
    <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="120px" class="demo-dynamic">
      <el-form-item prop="useScenarios" label="接口名称" :rules="[{ required: true, message: '请选择您要申请的接口名称', trigger: ['blur','change'] }]">
        <el-select v-model="dynamicValidateForm.useScenarios" placeholder="请选择您要申请的接口名称">
          <el-option :label="item.name" :value="item.name" v-for="(item, index) in list" :key="index"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item prop="demand" label="申请原因" :rules="[{ required: true, message: '请输入申请原因', trigger: 'blur' }]">
        <el-input v-model="dynamicValidateForm.demand" placeholder="请输入申请原因"></el-input>
      </el-form-item>
      <el-form-item>
        <div class="resetForm" @click="cancelDialog">取消</div>
        <div class="submitForm" @click="submitForm('dynamicValidateForm')">立即申请</div>
      </el-form-item>
    </el-form>
    <img class="sc3" src="../assets/images/sc_3@2x.png">
  </el-dialog>
  <!--反馈弹窗-->
  <SmallDialog ref="smallDialog" tip="申请成功！" name="Service"></SmallDialog>
</div>
</template>
<script>
  import {
    fetchAddNeed,
    fetchUserData
  } from '@/api/api'
  import SmallDialog from './smallDialog.vue'
  export default {
    data() {
      return {
        dialogFormVisible: false,
        dynamicValidateForm: { // todo 参数
          useScenarios: '',
          demand: ''
        },
        list:[
        {
          name: '接口名称1',
        },
        {
          name: '接口名称2',
        },
        {
          name: '接口名称3',
        },
        {
          name: '接口名称4'
        }
        ],
      };
    },
    components: {
      SmallDialog
    },
    watch: {
      dialogData: {
        handler() {
          this.dialogFormVisible = this.dialogData
          if(this.dialogFormVisible) {
            this.getUserData()
          }
        },
        immediate: true
      }
    },
    props: ['dialogData'],
    methods: {
      getUserData() {
        fetchUserData().then(res => {
          const {companyName, realname, nickName, phone} = res.data
          // this.dynamicValidateForm.companyName = companyName
          // this.dynamicValidateForm.name = realname
          // this.dynamicValidateForm.phone=phone
          if(!companyName || !realname || !nickName) {
            this.$message.error('请先完善信息')
            this.goAddInfo()
          }
        })
      },
      goAddInfo() {
        this.$router.push({
          name: 'PersonalData'
        })
      },
      cancelDialog() {
        this.resetForm('dynamicValidateForm')
        this.$emit('changeVisible', false)
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // todo
            fetchAddNeed(this.dynamicValidateForm).then(res => {
              if(res.code === 0) {
                this.$message.error(res.msg)
              }else {
                this.$refs.smallDialog.openDialog()
                this.$refs[formName].resetFields();
                this.$emit('changeVisible', false)
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  }
</script>
<style scoped>
  /deep/ .el-select {
    width: 100%;
  }

  /deep/ .el-dialog {
    width: 643px;
    height: 445px;
    background: url('../assets/images/dialogBg@2x.png') top left no-repeat;
    background-size: 100% 100%;
    padding-top: 30px;
    position: relative;
  }

  .el-form-item {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  /deep/ .el-form-item__label {
    margin-left: 60px !important;
    width: 476px !important;
    text-align: left !important;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #0A0909;
  }

  /deep/ .el-form-item__content {
    margin-left: 60px !important;
    width: 476px !important;
  }

  .submitForm {
    width: 220px;
    height: 45px;
    background: #0F5EFF;
    border-radius: 23px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 22px;
    text-align: center;
    line-height: 45px;
    margin-top: 30px;
    cursor: pointer;
  }

  .resetForm {
    width: 220px;
    height: 45px;
    background: #E8EDF6;
    border-radius: 23px;
    ont-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #A7AFC3;
    line-height: 22px;
    text-align: center;
    line-height: 45px;
    margin-top: 30px;
    cursor: pointer;
  }

  /deep/ .el-dialog__body {
    padding: 15px 20px
  }

  /deep/ .el-form-item__content {
    display: flex;
    justify-content: space-between;
  }

  /deep/ .el-input__inner {
    height: 45px;
  }

  /deep/ .el-dialog__header {
    width: 476px;
    margin: 0 auto;
  }

  /deep/ .el-dialog__title {
    font-size: 26px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #0A0909;
    line-height: 37px;
  }

  .sc3 {
    width: 100px;
    height: 48px;
    position: absolute;
    bottom: 70px;
  }
</style>



// WEBPACK FOOTER //
// src/components/apiServiceDialog.vue